<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col cols=8>
                    <b-card>
                        <b-container fluid>
                            
                        <b-row>
                            <b-col cols="3">
                                <label >{{ $t('replacementRules.configuration') }}</label>
                                <SelectList :options="configOptions" :value="configId" @select="onSelectConfig"/>
                            </b-col>
                            <b-col class="pt-3">
                            <TableActionHeader
                                ref="actionHeader" 
                                v-on:newItem="onNewRule"
                                :newButton="true"
                                :searchInput="false" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="3">
                                <label>{{ $t('replacementRules.textType') }}</label>
                                <SelectList
                                :options="ruleOptions" :value="ruleTypeId" @select="onSelectType"/>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <ReplacementRuleTable :configurationId="configId" :ruleType="ruleTypeId" @ruleSelected="onRuleSelected"/>
                            </b-col>
                        </b-row>
                        </b-container>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card>
                        <ReplacementRuleForm :rule="selectedRule" :action="action"/>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import replacementRules from '@/store/realtime/replacementRules'
const ReplacementRuleTable = () => import('@/components/Realtime/ReplacementRuleTable.vue')
const ReplacementRuleForm = () => import('@/components/Realtime/ReplacementRuleForm.vue')

export default {
    name: 'ReplacementRules',
    components: { ReplacementRuleTable, ReplacementRuleForm },
    data: function() {
        return {
            configOptions: [
                { id:0, label: 'Nova24', icon:'list' },
                { id:1, label: 'Driver', icon:'list' }
            ],
            configId: 1,
            ruleOptions: [
                { id:'DESTINATION_TEXT', label: 'Destination', icon:'list' },
                { id:'STOP_NAME', label: 'Stop name', icon:'list' }
            ],
            ruleTypeId: 'DESTINATION_TEXT',
            selectedRule: null,
            action: 'new'        
        }
    },
    computed: {
        ruleConfigs() {
            return this.$store.getters['replacementRules/getReplacementRuleConfigs']
        }
    },
    watch: {
        ruleConfigs(newItems) {
            const newOptions = []
            for( let config of newItems ) {
                newOptions.push( 
                    {  
                        id: config.id,
                        label: config.type,
                        icon: 'list'
                     }
                )
            }
            this.configOptions = newOptions
            this.configId = this.configOptions[0].id
        }
    },
    methods: {
        onSelectType(newType) {
            this.ruleTypeId = newType
            this.selectedRule = null
        },
        onSelectConfig(newConfig) {
            this.configId = newConfig
            this.selectedRule = null
        },
        onRuleSelected( rule ) {
            if( rule == undefined || rule == null )
                return
            const newRule = { ...rule }
            if( isNotSet(newRule.ruleConfigurationId ) ) newRule.ruleConfigurationId = this.configId
            if( isNotSet(newRule.type )) newRule.type = this.ruleTypeId
            if( rule.id == undefined || rule.id == null ) {
                this.action='new'
            } else {
                this.action='item'
            }
            this.selectedRule = newRule
        },
        onNewRule() {
            this.action='new'
            const newRule = {
                ruleConfigurationId: this.configId,
                type: this.ruleTypeId
            }
            this.selectedRule = newRule
        }
    },
    beforeCreate() {
        if( !this.$store.state.replacementRules ) {
            this.$store.registerModule("replacementRules" , replacementRules )
        }
    },
    mounted() {
        this.$store.dispatch('replacementRules/getReplacementRuleConfigs')
    }
}

function isNotSet( value ) {
    return value == undefined || value == null 
}

</script>
<style scoped lang="css">

::v-deep .table > tbody > tr.rule > td {
    color: black;
}
::v-deep .table > tbody > tr.example > td {
    color: grey;
}

</style>